export function removeSelection() {
  if (window.getSelection) {
    const selection = window.getSelection();

    if (selection.removeAllRanges) {
      selection.removeAllRanges();
    }
  }
}
